import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useBulkReviewRequirements } from "../hooks/useBulkReviewRequirements";

export const RouteBulkReviewRequirements = () => {
  const history = useHistory();
  const { queryRequirements } = useBulkReviewRequirements();

  useEffect(() => {
    const requirement = queryRequirements.data?.pages[0]?.data[0];

    if (requirement) {
      history.replace({
        pathname: `/member/payees/${requirement.payeeId}/requirement/${requirement.requirementId}`,
        search: history.location.search
      });
    }
  }, [queryRequirements.data, history, history.location.search]);

  return null;
};
